import { Box, Card, CardContent, Divider, FormControl, FormControlLabel, FormLabel, Grid2, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import AsyncButton from "../../components/common/AsyncButton";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { TextField } from '@mui/material';
import { InvokeAPI } from "../../apis/API";
import { getAssessmentMgmtBase } from "../../config/apiBase";
import { useAuth } from "../../contexts/AuthContext";
import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined';
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import InfoIcon from "@mui/icons-material/Info";
import ClassIcon from '@mui/icons-material/Class';


const AssessmentAdaptiveAttempt = () => {
    const { id } = useParams();
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [attemptstarted, setAttemptstarted] = useState("false");
    const [questionIndex, setQuestionIndex] = useState({
        index: 0,
        adaptiveLevel: 2,
    });
    const [response, setResponse] = useState({
        'old': "",
        'new': "",
    });

    const [questionTimer, setQuestionTimer] = useState(0);
    const [globalRemaining, setGlobalRemaining] = useState(0);

    const [assessmentData, setAssessmentData] = useState({
        name: '',
        subject: '',
        class: '',
        duration: 0,
    });
    const getAssessmentMeta = async () => {
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/id`,
            { "ID": id },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        //TODO:Check if isAdaptive else error
        if (uinfo.response["AssessmentInfo"]["IsAdaptive"] !== true) {
            navigate("/app/practice/")
        }
        return uinfo.response["AssessmentInfo"]
    }

    const formatDuration = (minutes) => {
        const total = parseInt(minutes, 10);
        if (!total || total === 0) {
            return '';
        }
        const hours = Math.floor(total / 60);
        const mins = total % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };

    useEffect(() => {
        //Some function
        getAssessmentMeta().then(data => setAssessmentData({
            name: data.Aname,
            class: data.Aclass,
            subject: data.Asubject,
            duration: data.Duration || 0,
        }))
    }, [])

    const updateAttemptInfo = async (remainingSeconds) => {
        const durationMinutes = Math.floor(remainingSeconds / 60);

        try {
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/attempt/update`,
                {
                    "Aid": id,
                    "State": "In Progress",
                    "Duration": durationMinutes,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
        } catch (error) {
            // Silently fail - don't interrupt the user's attempt
            console.error("Failed to update attempt info:", error);
        }
    };

    // Per-question timer (tracks time spent on current question) - runs in background
    useEffect(() => {
        if (attemptstarted !== "true") return;
        const interval = setInterval(() => {
            setQuestionTimer((prev) => prev + 1);
        }, 1000);
        return () => clearInterval(interval);
    }, [attemptstarted]);

    // Initialize global countdown when attempt starts and duration is set
    useEffect(() => {
        if (attemptstarted !== "true" || assessmentData.duration <= 0) return;
        setGlobalRemaining(assessmentData.duration * 60);
    }, [attemptstarted, assessmentData.duration]);

    // Global countdown timer - on zero, auto-submit the attempt
    useEffect(() => {
        if (attemptstarted !== "true" || assessmentData.duration <= 0 || globalRemaining <= 0) return;

        const interval = setInterval(() => {
            setGlobalRemaining(prev => {
                if (prev <= 1) {
                    clearInterval(interval);
                    handleSubmit(-1);
                    return 0;
                }
                //TODO: if prev%60 == 0 then API to update attemptifo
                if (prev % 60 === 0) {
                    updateAttemptInfo(prev);
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [attemptstarted, assessmentData.duration, globalRemaining]);
    const getAttemptInfo = async () => {
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/attempt/info`,
            {
                "Aid": id,
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        // Return first element from AttemptInfo array, or default object if empty
        const attemptInfoArray = uinfo.response?.AttemptInfo || [];
        return attemptInfoArray.length > 0 ? attemptInfoArray[0] : { Duration: 0, State: "", Aversion: 0 };
    };


    async function getQuestions() {
        //TODO: this guy can return the timer as it will have the data
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/question/list`,
            {
                "Aid": id,
                "FillMeta": true,
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return uinfo.response["QuestionsInfo"]
    }

    const handleAttemptStart = async (e) => {
        //TODO: getAttemptInfo, depending upon state set the question, qindex, duration accordingly
        const attemptinfo = await getAttemptInfo()
        if (attemptinfo.Duration !== 0) {
            setAssessmentData(prev => ({ ...prev, duration: attemptinfo.Duration }))
            setGlobalRemaining(attemptinfo.Duration * 60)
            sessionStorage.setItem("questions", JSON.stringify(attemptinfo.QuestionsInfo))
            setAttemptstarted("true")
            setQuestionIndex({ "index": attemptinfo.Qindex, "adaptiveLevel": attemptinfo.AdaptiveLevel })
            setQuestionTimer(0)
        } else {
            //Since there is no attempt this is first time so crate the attempt with inprogress state
            const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/attempt/create`,
                {
                    "Aid": id,
                },
                'POST',
                { "authorization": user["token"] },
                false)
            if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                logout(user);
            }
            console.log(uinfo)
            setGlobalRemaining(assessmentData.duration * 60)
            //if first time do the following
            console.log("going for questions..")
            const questions = await getQuestions()
            console.log("got for questions..")
            sessionStorage.setItem("questions", JSON.stringify(questions))
            setAttemptstarted("true")
            setQuestionIndex({ "index": 1, "adaptiveLevel": 2 })
            setQuestionTimer(0)
        }

    }

    const RenderTimer = () => {
        // Hide per-question timer if global timer is active
        if (assessmentData.duration > 0) return null;

        const hours = Math.floor(questionTimer / 3600);
        const minutes = Math.floor((questionTimer % 3600) / 60);
        const seconds = Math.floor(questionTimer % 60);
        return (
            <Box
                display="flex"
                justifyContent="flex-end"
                alignItems="center"
                sx={{
                    paddingTop: "20px",
                    paddingRight: "20px",
                    gap: 1
                }}
            >
                <AccessAlarmOutlinedIcon sx={{ color: 'error.main', fontSize: '1.5rem' }} />
                <Typography
                    variant="h5"
                    sx={{
                        color: 'error.main',
                        fontWeight: 700,
                        fontFamily: 'monospace',
                        letterSpacing: '0.1em'
                    }}
                >
                    {String(hours).padStart(2, '0')}:
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                </Typography>
            </Box>
        )
    }

    const RenderGlobalTimer = () => {
        if (assessmentData.duration <= 0 || globalRemaining <= 0) return null;

        const hours = Math.floor(globalRemaining / 3600);
        const minutes = Math.floor((globalRemaining % 3600) / 60);
        const seconds = Math.floor(globalRemaining % 60);

        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    paddingTop: "20px",
                    paddingBottom: "10px",
                    gap: 1
                }}
            >
                <AccessAlarmOutlinedIcon sx={{ color: 'primary.main', fontSize: '2rem' }} />
                <Typography
                    variant="h4"
                    sx={{
                        color: 'primary.main',
                        fontWeight: 700,
                        fontFamily: 'monospace',
                        letterSpacing: '0.1em',
                        fontSize: '2rem'
                    }}
                >
                    {String(hours).padStart(2, '0')}:
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                </Typography>
            </Box>
        )
    }

    const saveResponse = async (QID) => {
        //TODO: take question index and question from response
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/answer/create`,
            {
                "Aid": id,
                "Qid": QID,
                "Rtext": response.new,
                "Rtime": questionTimer,
                "AdaptiveLevel": questionIndex["adaptiveLevel"],
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        return uinfo.response
    }

    const handleNext = async (currentQID, questions) => {
        const next = await saveResponse(currentQID)
        sessionStorage.setItem("questions", JSON.stringify(next["QuestionsInfo"]))
        setQuestionIndex({ index: next["Qindex"], adaptiveLevel: next["AdaptiveLevel"] })
        setQuestionTimer(0)
        setResponse({ old: "", new: "" })
    }

    const handleSubmit = async (currentQID) => {
        if (currentQID !== -1) {
            if (response.new !== response.old) {
                await saveResponse(currentQID)
            }
        }

        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/attempt/update`,
            {
                "Aid": id,
                "State": "completed",
            },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        console.log(uinfo)
        //Just call attempt done! and navigate to list
        navigate("/app/practice/")
    }

    const renderQuestion = () => {
        const questions = JSON.parse(sessionStorage.getItem("questions"))
        const question = questions[0]
        //console.log(question)
        var questionId = questionIndex["index"]
        var isLast = false
        console.log(questionId)
        console.log(questionIndex["index"])
        if (questionIndex["index"] == -1) {
            questionId = 10
            isLast = true
        }
        //TODO: check for someone changing the question content and XSS attack
        return (
            <>
                <Box sx={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
                    <Card
                        elevation={6}
                        sx={{
                            borderRadius: 4,
                            border: '1px solid',
                            borderColor: 'divider',
                            boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            mb: 3
                        }}
                    >
                        <CardContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', minHeight: '200px' }}>
                            <Stack spacing={3}>
                                {question && question.MetaText !== "" && (
                                    <>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {questionId}. Passage
                                        </Typography>
                                        <Box
                                            sx={{
                                                p: 2,
                                                borderRadius: 2,
                                                backgroundColor: 'action.hover',
                                                border: '1px solid',
                                                borderColor: 'divider'
                                            }}
                                        >
                                            <Typography variant="body1" sx={{ lineHeight: 1.8 }}>
                                                {question.MetaText}
                                            </Typography>
                                        </Box>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                color: 'text.primary',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {questionId}. {question.Questions[0].Question}
                                        </Typography>
                                    </>
                                )}
                                {question && question.MetaText === "" && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '150px' }}>
                                        <Typography
                                            variant="h5"
                                            sx={{
                                                fontWeight: 600,
                                                color: 'primary.main',
                                                textAlign: 'center'
                                            }}
                                        >
                                            {questionId}. {question.Questions[0].Question}
                                        </Typography>
                                    </Box>
                                )}
                            </Stack>
                        </CardContent>
                    </Card>
                </Box>
                {question && question.Questions && question.Questions[0].Options.length === 0 && (
                    <Box sx={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
                        <Card
                            elevation={6}
                            sx={{
                                borderRadius: 4,
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                mb: 3
                            }}
                        >
                            <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                                <TextField
                                    name="response"
                                    label={response.new ? "" : "Answer"}
                                    value={response.new}
                                    onChange={e => setResponse({ 'new': e.target.value })}
                                    autoComplete="off"
                                    autoFocus
                                    sx={{
                                        width: '100%',
                                        maxWidth: '600px',
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: 2,
                                            '& fieldset': {
                                                borderColor: 'divider',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: 'primary.main',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: 'primary.main',
                                                borderWidth: '2px',
                                            },
                                            '& .MuiInputBase-input': {
                                                textAlign: 'center',
                                            },
                                        },
                                    }}
                                    InputLabelProps={{
                                        shrink: false,
                                    }}
                                />
                            </CardContent>
                        </Card>
                    </Box>
                )}
                {question && question.Questions && question.Questions[0].Options.length !== 0 && (
                    <Box sx={{ padding: '20px', width: '100%', maxWidth: 640, margin: '0 auto' }}>
                        <Card
                            elevation={6}
                            sx={{
                                borderRadius: 4,
                                border: '1px solid',
                                borderColor: 'divider',
                                boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                mb: 3
                            }}
                        >
                            <CardContent sx={{ paddingLeft: '30px' }}>
                                <FormControl fullWidth>
                                    <FormLabel
                                        id="options-selection"
                                        sx={{
                                            marginBottom: '10px',
                                            fontWeight: 600,
                                            fontSize: '1rem',
                                            color: 'text.primary'
                                        }}
                                    >
                                        Select an Option
                                    </FormLabel>
                                    <RadioGroup
                                        name="options"
                                        value={response.new}
                                        onChange={e => setResponse({ 'new': e.target.value })}
                                    >
                                        {question.Questions[0].Options.map((row, index) => (
                                            <FormControlLabel
                                                key={index}
                                                value={row}
                                                control={
                                                    <Radio
                                                        sx={{
                                                            '&.Mui-checked': {
                                                                color: 'primary.main',
                                                            },
                                                        }}
                                                    />
                                                }
                                                label={
                                                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                        {String.fromCharCode(65 + index)}. {row}
                                                    </Typography>
                                                }
                                                sx={{
                                                    width: '100%',
                                                    marginBottom: '10px',
                                                    p: 1.5,
                                                    borderRadius: 2,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    backgroundColor: response.new === row ? 'action.selected' : 'transparent',
                                                    transition: 'all 0.2s ease-in-out',
                                                    '&:hover': {
                                                        backgroundColor: 'action.hover',
                                                        borderColor: 'primary.main',
                                                    },
                                                }}
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>
                            </CardContent>
                        </Card>
                    </Box>
                )}
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                    sx={{
                        paddingTop: "30px",
                        paddingBottom: "30px"
                    }}
                >
                    {
                        isLast === false ? (
                            <AsyncButton
                                size="large"
                                type="submit"
                                variant="contained"
                                color="success"
                                onClick={
                                    async (e) => {
                                        e.preventDefault();
                                        await handleNext(question.Questions[0].QID, questions);
                                    }
                                }
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 2,
                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                    boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                    '&:hover': {
                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                Next
                            </AsyncButton>
                        ) : (
                            <AsyncButton
                                size="large"
                                type="submit"
                                variant="contained"
                                color="success"
                                onClick={
                                    async (e) => {
                                        e.preventDefault();
                                        await handleSubmit(question.Questions[0].QID);
                                    }
                                }
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    fontSize: '1rem',
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: 2,
                                    background: 'linear-gradient(90deg, #2e7d32 0%, #4caf50 100%)',
                                    boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                    '&:hover': {
                                        background: 'linear-gradient(90deg, #1b5e20 0%, #2e7d32 100%)',
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                Submit
                            </AsyncButton>
                        )
                    }
                </Box>
            </>
        )
    }

    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }} >
            <Box justifyContent="center" alignItems="center" >
                {attemptstarted !== "true" ?
                    <>
                        <Box
                            sx={{
                                bgcolor: "transparent",
                                display: "flex",
                                justifyContent: "center",
                                p: 3,
                            }}
                        >
                            <Card
                                elevation={6}
                                sx={{
                                    maxWidth: 600,
                                    borderRadius: 4,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    '&:hover': {
                                        boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                                        transform: 'translateY(-2px)',
                                    },
                                }}
                            >
                                <CardContent>
                                    {/* Title */}
                                    <Typography
                                        variant="h4"
                                        align="center"
                                        gutterBottom
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        📝{" "}
                                        <Box
                                            component="span"
                                            sx={{
                                                background: 'linear-gradient(135deg, #00BCD4 0%, #4DD0E1 100%)',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                backgroundClip: 'text',
                                            }}
                                        >
                                            Assessment : {assessmentData.name}
                                        </Box>
                                    </Typography>

                                    <Typography
                                        variant="subtitle1"
                                        align="center"
                                        color="text.secondary"
                                        gutterBottom
                                    >
                                        Test your knowledge and improve your skills
                                    </Typography>

                                    <Divider sx={{ my: 2 }} />

                                    {/* Test details */}
                                    <Box display="flex" alignContent="center" justifyContent="center">
                                        <Grid2 container spacing={2} display="flex" alignItems="center" sx={{ mb: 3 }}>
                                            <Grid2 size="auto" display="flex" alignItems="center" gap={1}>
                                                <SchoolIcon sx={{ color: "brown" }} />
                                                <Typography variant="body1">Class: {assessmentData.class}</Typography>
                                            </Grid2>
                                            <Grid2 size="auto" display="flex" alignItems="center" gap={1}>
                                                <ClassIcon sx={{ color: "orange" }} />
                                                <Typography variant="body1">Subject: {assessmentData.subject}</Typography>
                                            </Grid2>
                                            {assessmentData.duration > 0 && (
                                                <Grid2 size="auto" display="flex" alignItems="center" gap={1}>
                                                    <AccessTimeIcon sx={{ color: "primary.main" }} />
                                                    <Typography variant="body1">
                                                        Duration: {formatDuration(assessmentData.duration)}
                                                    </Typography>
                                                </Grid2>
                                            )}
                                        </Grid2>
                                    </Box>

                                    {/* Instructions */}
                                    <Box mb={3}>
                                        <Typography variant="h6" gutterBottom>
                                            <InfoIcon fontSize="small" sx={{ mr: 1, verticalAlign: "middle" }} />
                                            Instructions
                                        </Typography>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                mb: 1,
                                                fontWeight: 700,
                                                color: 'warning.dark',
                                                bgcolor: 'rgba(255, 167, 38, 0.12)',
                                                px: 1.5,
                                                py: 1,
                                                borderRadius: 1,
                                                borderLeft: '3px solid',
                                                borderColor: 'warning.main',
                                            }}
                                        >
                                            • Do not type Units(kg/km/ml etc.) in the answer box.
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            • You cannot pause or restart the test once started.
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                            • Each question carries equal marks.
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            • Make sure you have a stable internet connection.
                                        </Typography>
                                    </Box>

                                    {/* Start Button */}
                                    <Box textAlign="center">
                                        <AsyncButton
                                            onClick={handleAttemptStart}
                                            variant="contained"
                                            size="large"
                                            startIcon={<RocketLaunchIcon />}
                                            sx={{
                                                background: 'linear-gradient(90deg, #00BCD4 0%, #4DD0E1 100%)',
                                                borderRadius: 2.5,
                                                padding: '12px 32px',
                                                fontWeight: 'bold',
                                                fontSize: '1rem',
                                                textTransform: 'none',
                                                boxShadow: '0 4px 12px rgba(0, 188, 212, 0.3)',
                                                '&:hover': {
                                                    background: 'linear-gradient(90deg, #0097A7 0%, #00BCD4 100%)',
                                                    transform: 'translateY(-2px)',
                                                    boxShadow: '0 6px 16px rgba(0, 188, 212, 0.4)',
                                                },
                                                transition: 'all 0.2s ease-in-out',
                                            }}
                                        >
                                            Start Test
                                        </AsyncButton>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>

                    </>
                    :
                    <Stack>
                        {assessmentData.duration > 0 && <RenderGlobalTimer />}
                        <RenderTimer />
                        {renderQuestion()}
                    </Stack>
                }
            </Box>
        </Box>
    );
};

export default AssessmentAdaptiveAttempt;
